import React from 'react';
import Title from 'antd/lib/typography/Title';
import { Button, message, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { fileImportActions } from '../redux-saga/actions';
import { getFileImport } from '../redux-saga/selectors';
import { FileImportState } from '../redux-saga/reducers';
import { RcFile } from 'antd/lib/upload/interface';

export enum FileType {
  CSV = 'text/csv',
  XLS = 'application/vnd.ms-excel',
  XLSM = 'application/vnd.ms-excel.sheet.macroenabled.12',
}

interface Props {
  field: keyof FileImportState;
  btnText: string;
  titleText: string;
  type: FileType;
}

const getFormatByType = (type: FileType) => {
  switch (type) {
    case FileType.CSV:
      return '.csv';
    case FileType.XLS:
      return '.xls';
    case FileType.XLSM:
      return '.xlsm';
    default:
      return '';
  }
};

export const FileImportUploader: React.FC<Props> = ({ field, btnText, titleText, type }) => {
  const dispatch = useDispatch();
  const fileImport = useSelector(getFileImport);
  const fileValue = fileImport[field] as RcFile;

  const uploadProps = {
    onRemove: _ => {
      dispatch(fileImportActions.setState({ [field]: null }));
    },
    beforeUpload: file => {
      const isCorrectType = [type.toLowerCase()].includes(file.type.toLowerCase());
      if (!isCorrectType) {
        message.error(`${file.name} is not a ${getFormatByType(type)} file`);
        return isCorrectType || Upload.LIST_IGNORE;
      }
      dispatch(fileImportActions.setState({ [field]: file }));

      return false;
    },
    fileList: fileValue ? [fileValue] : [],
    accept: getFormatByType(type),
  };

  return (
    <>
      <Title level={5}>{titleText || 'Upload File'}</Title>
      <Upload {...uploadProps}>
        <Button icon={<UploadOutlined />}>{btnText || 'Select File'}</Button>
      </Upload>
    </>
  );
};
